import React, { useState } from "react";
import { Table, Row, Col, Button, Spin } from "antd";
import { paintOrderColumns, primerOrderColumns } from "./columns";
import "../WorkOrderPaintC.less";
import Description from "./Description";
import OrderAmountCheck from "./OrderAmountCheck";
import { useHistory, useParams } from "react-router-dom";
import { useEffect } from "react";
import api from "../../../utils/api";
import { RootStateOrAny, useSelector } from "react-redux";
import axios from "axios";
import { getDistanceMiles } from "../../../utils/storeDistance";

type PaintOrderPreviewProps = {
  paintOrder: any;
  selectedStore: any;
};

const PaintOrderCom = () => {
  const { id } = useParams<{ id: string }>();
  const { online } = useSelector((state: RootStateOrAny) => state.offline);
  const history = useHistory();
  const [paint, setPaint] = useState<any>([]);
  const [primer, setPrimer] = useState<any>([]);
  const [toggleComponent, setToggleComponent] = useState(true);
  const [loading, setLoading] = useState(false);
  const [orderNo, setOrderNo] = useState(0);
  const [users, setUsers] = useState<any>([]);
  const [comments, setComments] = useState<any>("");
  const [oldDeliveryContact, setOldDeliveryContact] = useState<any>({});
  const [oldOrderContact, setOldOrderContact] = useState<any>({});
  const [deliveryNotes, setDeliveryNotes] = useState<any>("");

  const { items, currentProject, adminDefaults } = useSelector(
    (state: RootStateOrAny) => state.offlineData,
  );

  const [storeLocations, setStoreLocations] = useState([
    ...adminDefaults?.storeLocations,
  ]);

  const [closestStore, setClosestStore] = useState<any>({});

  const [jobSiteLocation, setJobSiteLocation] = useState<any>([]);
  const productionAssociateEmail =
    items[currentProject].projectInfo?.productionAssociate?.email;
  useEffect(() => {
    if (!storeLocations || storeLocations.length === 0) return;
    setLoading(true);
    let storeLocationsArray = [...storeLocations];
    getPreviousPaintOrderDetails();
    getAllUsers();
    axios
      .get(
        `https://script.google.com/macros/s/AKfycbzIjxF2qlxsKT-Spz0BClilOuaOI19gMAvSva9nt6yfRQWZJpQGjmwYKtP_RMIGfOJk/exec?address=${items[currentProject].paintOrder?.jobSiteAddress}`,
      )
      .then((resp: any) => {
        if (resp?.data?.length > 0) {
          setJobSiteLocation(resp.data);
          let paintOrderAccount =
            items[currentProject].paintOrder?.accountNumber.split(":");
          const vendorSelectedIndex = adminDefaults.vendorDefaults.findIndex(
            (item: any) => item.accountNumber === paintOrderAccount[0],
          );
          // let filteredArray = storeLocationsArray.filter(
          //   (item: any) => item.store === vendorSelected.prefix
          // );
          const vendorSelected =
            adminDefaults.vendorDefaults[vendorSelectedIndex];

          let filteredArray = storeLocationsArray.filter((item) =>
            vendorSelected.prefix.includes(item.store),
          );
          // let filteredArray = storeLocationsArray.filter(
          //   (item) => item.store === vendorSelected[0].prefix[0]
          // );

          let updatedArray = filteredArray.map((item: any) => {
            let distanceFromJobSite = getDistanceMiles(
              resp.data[0],
              resp.data[1],
              item.latitude,
              item.longitude,
            );
            let mapLink = `https://www.google.com/maps/dir/?api=1&origin=${items[
              currentProject
            ].paintOrder?.jobSiteAddress
              ?.split(" ")
              .join("+")}&destination=${item.address
              ?.split(" ")
              .join("+")}&travelmode=driving`;
            return {
              ...item,
              mapLink,
              distanceFromJobSite,
            };
          });

          const validStores = updatedArray.filter((item: any) =>
            Number.isFinite(item.distanceFromJobSite),
          );

          if (validStores.length > 0) {
            const smallestObj = validStores.reduce(
              (min: any, obj: any) =>
                obj.distanceFromJobSite < min.distanceFromJobSite ? obj : min,
              validStores[0],
            );
            setClosestStore(smallestObj ?? {});
          } else {
            setClosestStore({});
          }
          setStoreLocations(updatedArray);
        }
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (toggleComponent !== false) {
      getPreviousPaintOrderDetails();
    }
  }, [toggleComponent]);

  const getAllUsers = async () => {
    try {
      const users = await api.get("user/all-users");
      setUsers(users);
    } catch (err: any) {
      console.log(err);
    }
  };

  const getPreviousPaintOrderDetails = () => {
    api.get(`place-order/${id}`).then((resp: any) => {
      setDeliveryNotes(resp.deliveryNotes);
      setComments(resp.comments);
      setOldDeliveryContact(resp.deliveryContact);
      setOldOrderContact(resp.orderContact);
      updateGallons(resp);
    });
  };

  const updateGallons = (resp: any, toggle?:boolean) => {
    let updatedPaint = [];
    let updatedPrimer = [];
    if (resp.orderNo) {
      setOrderNo(resp.orderNo);
    }
    if (resp?.paintInfo?.length > 0) {
      updatedPaint = items[currentProject].paintOrder?.paintInfo?.map(
        (item: any) => {
          const material = resp.paintInfo.find((product: any) => {
            const productMatch = product.product === item.product;
            if (product.color === undefined) {
              return productMatch;
            }
            return productMatch && (product.color || '') === (item.color || '');
          });
          return material
            ? { ...item, orderedGallons: material.gallons }
            : { ...item };
        },
      );
    } else {
      updatedPaint = items[currentProject].paintOrder?.paintInfo?.map(
        (item: any) => {
          return { ...item, orderedGallons: 0 };
        },
      );
    }
    if (resp?.primerInfo?.length > 0) {
      updatedPrimer = items[currentProject].paintOrder?.primerInfo?.map(
        (item: any) => {
          const material = resp.primerInfo.find(
            (product: any) => product.primer === item.primer,
          );
          return material
            ? { ...item, orderedGallons: material.gallons }
            : { ...item };
        },
      );
    } else {
      updatedPrimer = items[currentProject].paintOrder?.primerInfo?.map(
        (item: any) => {
          return { ...item, orderedGallons: 0 };
        },
      );
    }
    setPaint(updatedPaint);
    setPrimer(updatedPrimer);
    if(toggle) handleToggle()
  };
  const newColumn = [
    paintOrderColumns[0],
    {
      title: (
        <>
          <Row>
            <Col>
              <div
                style={{
                  height: 20,
                  width: 20,
                  // marginTop:8,
                  marginRight: 20,
                }}
              />
            </Col>
            <Col>Color</Col>
          </Row>
        </>
      ),
      dataIndex: "color",
      width: "40%",
      render: (data: string) => {
        let response = adminDefaults.colors.find(
          (item: any) => item.name === data,
        );
        return (
          <>
            <Row>
              <Col>
                <div
                  style={{
                    background: response?.hexCode,
                    height: 20,
                    width: 20,
                    marginRight: 20,
                  }}
                />
              </Col>
              <Col>
                <p>{data}</p>
              </Col>
            </Row>
          </>
        );
      },
    },
    paintOrderColumns[2],
    paintOrderColumns[3],
  ];

  const handleProductOrder = () => {
    setToggleComponent(false);
  };

  const handleNext = () => {
    history.push(`/wood-order/${id}`);
  };
  const handleToggle = () => {
    setToggleComponent(true);
  };
  const handleUpdateState = (data: any, toggle?:boolean) => {
    updateGallons(data,toggle);
  };

  const handleClosestStoreChange = (val: any) => {
    setClosestStore(val);
  };

  const PaintOrderPreview: React.FC<PaintOrderPreviewProps> = ({
    paintOrder,
    selectedStore,
  }) => {
    return (
      <>
        <div className="wo-paint-root ">
          <h1 className="wop-title wop-header">Paint Order</h1>
          <hr style={{ border: "1px solid #E8E8E8" }} />
          <Row style={{ padding: "30px 15px" }}>
            <Col span={24}>
              <Description
                title="paintOrder"
                paintOrder={paintOrder}
                selectedStore={selectedStore}
              />
            </Col>
          </Row>
          <div className="wo-paint-table">
            <div>
              <Table
                rowKey="_id"
                pagination={false}
                rowClassName={(record, index) =>
                  index % 2 === 0
                    ? "table_row table-row-light"
                    : "table_row table-row-dark"
                }
                columns={primerOrderColumns}
                dataSource={primer?.filter((item: any) => item.primeGallons)}
              />
            </div>
            <div>
              <Table
                rowKey="_id"
                pagination={false}
                rowClassName={(record, index) =>
                  index % 2 === 0
                    ? "table_row table-row-light"
                    : "table_row table-row-dark"
                }
                columns={newColumn}
                dataSource={paint?.filter((item: any) => item.paintGallons)}
              />
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {loading ? (
        <Row style={{ padding: "80px 0px" }} justify="center">
          <Spin size="large" />
        </Row>
      ) : (
        <div>
          {toggleComponent ? (
            <>
              <PaintOrderPreview
                paintOrder={{
                  ...items[currentProject].paintOrder,
                  ...items[currentProject].prePresentationChecklist,
                }}
                selectedStore={closestStore}
              />
              <Row justify="center" style={{ marginTop: "50px" }}>
                <Col>
                  <Row
                    gutter={20}
                    style={{ marginBottom: 20 }}
                    justify="center"
                  >
                    <Col>
                      <Button
                        onClick={handleProductOrder}
                        className="initial-product-btn"
                        type="primary"
                        disabled={!online}
                      >
                        Initiate Product Order
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        onClick={handleNext}
                        type="primary"
                        className="next-btn-po"
                      >
                        Next
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </>
          ) : (
            <OrderAmountCheck
              paintOrder={{
                ...items[currentProject].paintOrder,
                ...items[currentProject].prePresentationChecklist,
              }}
              orderNo={orderNo}
              paintMaterials={paint}
              primerMaterials={primer}
              handleToggle={handleToggle}
              closestStore={closestStore}
              setClosestStore={setClosestStore}
              jobSiteLocation={jobSiteLocation}
              handleUpdateState={handleUpdateState}
              productionAssociateEmail={productionAssociateEmail}
              users={users}
              comments={comments}
              setComments={setComments}
              deliveryNotes={deliveryNotes}
              setDeliveryNotes={setDeliveryNotes}
              oldDeliveryContact={oldDeliveryContact}
              oldOrderContact={oldOrderContact}
            />
          )}
        </div>
      )}
    </>
  );
};

export default PaintOrderCom;
